import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import './App.css';

import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import PortalLayout from './components/PortalLayout';
import Dashboard from './pages/Portal/Dashboard';
import Chamados from './pages/Portal/Chamados';
import Senhas from './pages/Portal/Senhas';
import Projetos from './pages/Portal/Projetos';
import Usuarios from './pages/Portal/Usuarios';
import Clientes from './pages/Portal/Clientes';
import Leads from './pages/Portal/Leads';
import CRMDashboard from './pages/Portal/CRMDashboard';
import CRMKanban from './pages/Portal/CRMKanban';
import CRMAlertas from './pages/Portal/CRMAlertas';
import TaskBoards from './pages/Portal/Tasks/TaskBoards';
import TaskKanban from './pages/Portal/Tasks/TaskKanban';
import TaskDashboard from './pages/Portal/Tasks/TaskDashboard';
import TaskCalendar from './pages/Portal/Tasks/TaskCalendar';
import TaskListView from './pages/Portal/Tasks/TaskListView';
import DashboardFinanceiro from './pages/Portal/Financeiro/DashboardFinanceiro';
import Contratos from './pages/Portal/Financeiro/Contratos';
import Receitas from './pages/Portal/Financeiro/Receitas';
import Despesas from './pages/Portal/Financeiro/Despesas';
import Configuracoes from './pages/Portal/Financeiro/Configuracoes';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem('user');
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          
          <Route
            path="/portal"
            element={
              <ProtectedRoute>
                <PortalLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="chamados" element={<Chamados />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="senhas" element={<Senhas />} />
            <Route path="projetos" element={<Projetos />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="leads" element={<Leads />} />
            <Route path="crm/dashboard" element={<CRMDashboard />} />
            <Route path="crm/kanban" element={<CRMKanban />} />
            <Route path="crm/alertas" element={<CRMAlertas />} />
            <Route path="tasks" element={<TaskBoards />} />
            <Route path="tasks/board/:boardId" element={<TaskKanban />} />
            <Route path="tasks/list" element={<TaskListView />} />
            <Route path="tasks/dashboard" element={<TaskDashboard />} />
            <Route path="tasks/calendar" element={<TaskCalendar />} />
            <Route path="financeiro" element={<DashboardFinanceiro />} />
            <Route path="financeiro/contratos" element={<Contratos />} />
            <Route path="financeiro/receitas" element={<Receitas />} />
            <Route path="financeiro/despesas" element={<Despesas />} />
            <Route path="financeiro/configuracoes" element={<Configuracoes />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;